<div class="toolbar-dev">
  <!-- Left: ENV badge -->
  <div class="toolbar-dev__left">
    <app-tenant-switcher />
  </div>

  <!-- Right: Angular version + Theme Picker + GitHub -->
  <div class="toolbar-dev__right">
    <button mat-button disabled class="toolbar-dev__version">Angular {{ angularVersion }}</button>

    <!-- GitHub — desktop: icon + label -->
    <a
      matButton="text"
      class="toolbar-dev__github-link toolbar-dev__github-desktop"
      href="https://github.com/abook-solution/abook-platform"
      aria-label="GitHub Repository"
      target="_blank"
      rel="noopener"
    >
      <span matButtonIcon [ngTemplateOutlet]="githubIcon"></span>
      GitHub
    </a>

    <!-- GitHub — mobile: icon only -->
    <a
      matIconButton
      class="toolbar-dev__github-mobile"
      href="https://github.com/abook-solution/abook-platform"
      aria-label="Abook GitHub Repository"
      target="_blank"
      rel="noopener"
    >
      <ng-container [ngTemplateOutlet]="githubIcon" />
    </a>

    <a
      mat-icon-button
      class="toolbar-dev__design-system-btn"
      routerLink="/design-system"
      aria-label="Design System"
    >
      <mat-icon>design_services</mat-icon>
    </a>

    <app-theme-switcher />

    <button
      mat-icon-button
      class="toolbar-dev__figma-btn"
      [matMenuTriggerFor]="figmaMenu"
      aria-label="Figma design files"
    >
      <ng-container [ngTemplateOutlet]="figmaIcon" />
    </button>

    <mat-menu #figmaMenu="matMenu" xPosition="before">
      <a
        mat-menu-item
        href="https://www.figma.com/design/6TAppOS5aVowYdWctgvDXV/"
        target="_blank"
        rel="noopener"
      >
        <mat-icon>design_services</mat-icon>
        <span>Design Library</span>
      </a>
      <a
        mat-menu-item
        href="https://www.figma.com/design/wn0mFSW5vCc9wrRZIXHspZ/"
        target="_blank"
        rel="noopener"
      >
        <mat-icon>auto_stories</mat-icon>
        <span>Pages / Flows</span>
      </a>
    </mat-menu>
  </div>
</div>

<!-- Figma SVG mark -->
<ng-template #figmaIcon>
  <svg viewBox="-9.5 0 57 57" aria-hidden="true" class="toolbar-dev__figma-icon">
    <path
      d="M19 28.5c0-5.247 4.253-9.5 9.5-9.5 5.247 0 9.5 4.253 9.5 9.5 0 5.247-4.253 9.5-9.5 9.5-5.247 0-9.5-4.253-9.5-9.5z"
      fill="#1abcfe"
    />
    <path
      d="M0 47.5C0 42.253 4.253 38 9.5 38H19v9.5c0 5.247-4.253 9.5-9.5 9.5C4.253 57 0 52.747 0 47.5z"
      fill="#0acf83"
    />
    <path d="M19 0v19h9.5c5.247 0 9.5-4.253 9.5-9.5C38 4.253 33.747 0 28.5 0H19z" fill="#ff7262" />
    <path d="M0 9.5C0 14.747 4.253 19 9.5 19H19V0H9.5C4.253 0 0 4.253 0 9.5z" fill="#f24e1e" />
    <path d="M0 28.5C0 33.747 4.253 38 9.5 38H19V19H9.5C4.253 19 0 23.253 0 28.5z" fill="#a259ff" />
  </svg>
</ng-template>

<!-- GitHub SVG mark -->
<ng-template #githubIcon>
  <svg viewBox="0 0 20 20" aria-hidden="true" class="">
    <path
      d="M10 0C4.477 0 0 4.477 0 10c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V19c0 .27.16.59.67.5C17.14 18.16 20 14.42 20 10A10 10 0 0 0 10 0z"
      fill="currentColor"
      fill-rule="evenodd"
    ></path>
  </svg>
</ng-template>
